import React, { useState } from "react";
import { useConfig } from "../../contexts/config";

const ForgotPasswordForm = ({ onBackToLogin }) => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [usernameTyping, setUsernameTyping] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const { config } = useConfig();
  const [error, setError] = useState('');


  

  const handleForgotPassword = async (event) => {
    event.preventDefault(); // Evita que el formulario recargue la página
    
    if (!username) {
      setError('Por favor, ingresa tu nombre de usuario.');
      return;
    }

    setLoading(true);
    setMessage('');
    setError('');

    // URL de tu endpoint. Asegúrate de que el dominio sea el correcto.
    const apiUrl = 'https://elearning.inatrans.cl/tipddy/services/restore-password.php/user/forgotpassword';

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: username,
          // Enviamos dinámicamente la URL base de esta aplicación React
          client_url: "https://participantes.inatrans.cl/" // ! window.location.origin,
        }),
      });
      console.log(response)
      const data = await response.json();

      if (response.ok && data.status === 200) {
 setMessage({ 
          type: "success", 
          text: "Hemos enviado un correo con instrucciones para recuperar tu contraseña" 
        });
        setUsername(''); // Limpiar el campo de nombre de usuario
      } else {
        // Usar el mensaje del backend si está disponible, o uno genérico
         setMessage({ 
          type: "error", 
          text: data.message || "No pudimos procesar tu solicitud. Verifica tu correo e intenta nuevamente." 
        });
      }
    } catch (err) {
      setMessage({ 
        type: "error", 
        text: "Ocurrió un error al procesar tu solicitud. Por favor intenta más tarde." 
      });
      console.error('Error en la solicitud de recuperación:', err);
    } finally {
      setUsernameTyping(false);
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-[32rem] justify-between m-4">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-3xl font-semibold text-zinc-200 mb-2">
          Recupera tu contraseña
        </h2>
        <p className="text-zinc-300 text-xl">
          Ingresa tu rut y te enviaremos instrucciones a tu correo para
          restablecer tu contraseña.
        </p>
      </div>

      {/* Form */}
      <form onSubmit={handleForgotPassword} className="space-y-6 ">
        <div className="mb-4">
          <label
            htmlFor="email"
            className="block text-2xl font-medium text-zinc-200 mb-2"
          >
            Rut (Sin puntos pero con guión y dígitos)
          </label>
          <input
            type="text"
            id="email"
            value={username}
            onChange={(e) => {
              setUsernameTyping(true)
              setUsername(e.target.value)}}
            placeholder=""
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all text-lg"
            required
            style={{
              marginBottom: ".2rem",
            }}
          />
        </div>

        {/* Message display */}
        {message.text && !usernameTyping ? (
          <div
            className={`p-3 rounded-lg ${
              message.type === "success"
                ? "bg-green-600/20 text-green-200"
                : "bg-red-600/20 text-red-200"
            }`}
          >
            {message.text}
          </div>
        ) : (
          <div
            className="space-y-4 pb-4"
            style={{
              marginBottom: ".5rem",
            }}
          >
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#44BCF9] hover:bg-[#41Bad8] text-[18px] text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                  <span>Procesando...</span>
                </div>
              ) : (
                "Enviar instrucciones"
              )}
            </button>
          </div>
        )}

        <button
          type="button"
          onClick={onBackToLogin}
          className="w-full border border-[#44BCF9] text-[#44BCF9] hover:bg-[#44BCF9]/10 text-[16px] font-medium py-2 px-4 rounded-lg transition-colors"
        >
          Volver al inicio de sesión
        </button>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;